import React from 'react'
import Link from 'gatsby-link'
import classNames from 'classnames/bind'
import styles from './Button.module.css'

let cx = classNames.bind(styles)

const Button = props => {
  let className = cx({
    btn: true,
    orange: props.orange,
    large: props.large,
  })

  return (
    <div className={styles.button}>
      <Link to={props.link} className={className}>
        {props.title}
      </Link>
    </div>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/Button.js